import { render, staticRenderFns } from "./ProgramHead.vue?vue&type=template&id=768970c4&"
import script from "./ProgramHead.vue?vue&type=script&lang=js&"
export * from "./ProgramHead.vue?vue&type=script&lang=js&"
import style0 from "./ProgramHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768970c4')) {
      api.createRecord('768970c4', component.options)
    } else {
      api.reload('768970c4', component.options)
    }
    module.hot.accept("./ProgramHead.vue?vue&type=template&id=768970c4&", function () {
      api.rerender('768970c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/program/ProgramHead.vue"
export default component.exports